module.exports = __webpack_public_path__ + "static/media/again@2x.b6560d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/again@2x.png
// module id = 895
// module chunks = 0